import React from 'react';
import {NonIdealState} from "@blueprintjs/core";

const NotFound = () => {
  return (
    <NonIdealState
      title='404'
      description='你访问的页面不存在'
      icon='zoom-out'
    />
  );
};

export default NotFound;
